import { ApproveDraftIcon } from 'foundations-assets/icons/components/ApproveDraftIcon';
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import { CampaignsIcon } from 'foundations-assets/icons/components/CampaignsIcon';
import { DataSyncIcon } from 'foundations-assets/icons/components/DataSyncIcon';
import { HubDBIcon } from 'foundations-assets/icons/components/HubDBIcon';
import { LayersIcon } from 'foundations-assets/icons/components/LayersIcon';
import { QuestionAnswerIcon } from 'foundations-assets/icons/components/QuestionAnswerIcon';
import { SequencesIcon } from 'foundations-assets/icons/components/SequencesIcon';
import { ServiceIcon } from 'foundations-assets/icons/components/ServiceIcon';
import { TicketIcon } from 'foundations-assets/icons/components/TicketIcon';
import { WorkflowsIcon } from 'foundations-assets/icons/components/WorkflowsIcon';
export const HUB_TYPE_ICONS = {
  'marketing-hub': CampaignsIcon,
  'sales-hub': WorkflowsIcon,
  'service-hub': QuestionAnswerIcon,
  'commerce-hub': WorkflowsIcon,
  'cms-hub': LayersIcon,
  'content-hub': LayersIcon,
  'operations-hub': HubDBIcon,
  'marketing-plus': [LayersIcon, CampaignsIcon],
  'hsoc-core-seats-professional': [CampaignsIcon, WorkflowsIcon, BreezeSingleStarIcon],
  'hsoc-core-seats-enterprise': [CampaignsIcon, DataSyncIcon],
  'hsoc-front-office-seats-professional': [SequencesIcon, ServiceIcon, BreezeSingleStarIcon],
  'hsoc-front-office-seats-enterprise': [ApproveDraftIcon, TicketIcon, ServiceIcon]
};
const getHubTypeFromApiName = apiName => {
  for (const hubType in HUB_TYPE_ICONS) {
    if (apiName.includes(hubType)) {
      return hubType;
    }
  }
  return null;
};
export const getIconForBullet = (apiName, bulletIndex = 0) => {
  const hubType = getHubTypeFromApiName(apiName);
  if (!hubType) {
    return LayersIcon;
  }
  const iconValue = HUB_TYPE_ICONS[hubType];
  if (Array.isArray(iconValue)) {
    return iconValue[bulletIndex] || iconValue[0];
  }
  return iconValue;
};
export const getNumBulletsForApiName = apiName => {
  const hubType = getHubTypeFromApiName(apiName);
  if (!hubType) {
    return 1;
  }
  const iconValue = HUB_TYPE_ICONS[hubType];
  return Array.isArray(iconValue) ? iconValue.length : 1;
};